"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationSchema = exports.PolygonSchema = exports.PointSchema = exports.CoordinatesSchema = void 0;
const joi_1 = __importDefault(require("joi"));
exports.CoordinatesSchema = joi_1.default.array().items(joi_1.default.number()).length(2).meta({ className: 'Coordinates' });
exports.PointSchema = joi_1.default.object({
    type: joi_1.default.string().valid('Point').required(),
    coordinates: exports.CoordinatesSchema.required()
}).meta({ className: 'Point' });
exports.PolygonSchema = joi_1.default.object({
    type: joi_1.default.string().valid('Polygon').required(),
    coordinates: joi_1.default.array().items(joi_1.default.array().items(exports.CoordinatesSchema)).required()
}).meta({ className: 'Polygon' });
exports.LocationSchema = joi_1.default.object({
    address: joi_1.default.string().required(),
    // TODO: sort out if any of those are universally required
    addressComponents: joi_1.default.object({
        city: joi_1.default.string(),
        country: joi_1.default.string(),
        countryCode: joi_1.default.string(),
        postalCode: joi_1.default.string(),
        street: joi_1.default.string(),
        streetNumber: joi_1.default.string()
    }).required(),
    plusCode: joi_1.default.string().allow(null),
    // This is defined as an enum in @googlemaps/google-maps-services-js, but we don't really trust their types here
    // @see https://github.com/googlemaps/google-maps-services-js/issues/669
    locationType: joi_1.default.string(),
    geometry: exports.PointSchema.required(),
    name: joi_1.default.string().allow('', null),
    timeZoneId: joi_1.default.string().required()
}).meta({ className: 'Location' });
//# sourceMappingURL=geography.js.map